import { AppBar, Box, Card, CardHeader, IconButton, Stack, Tab, Tabs, Tooltip } from "@mui/material"
import DashboardLayout from "../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../components/MaterialTypography"
import MaterialButton from "../../components/MaterialButton"
import { Approval, Edit, FileUpload, PersonSearch, Visibility } from "@mui/icons-material"
import MaterialDataGrid from "../../components/MaterialDataGrid"
import { useEffect, useState } from "react"
import MaterialBox from "../../components/MaterialBox"
import PolicyFileUploadDialog from "./components/PolicyFileUploadDialog"
import BASEURL from "../Utils/Baseurl"
import request from "graphql-request"
import { allPolicyList, userPolicyList } from "./components/Queries"
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog"
import { useUserDetails } from "../../context/auth"
import PolicyAcknowledgementDialog from "./components/PolicyAcknowledgementDialog"
import PolicyUserStatus from "./components/PolicyUserStatus"

const PolicyManagementList = () => {

    const userData = JSON.parse(sessionStorage.getItem("user"));
    const userId = userData.id;
    const { AccessData } = useUserDetails();
    const [isLoading, setIsLoading] = useState(false);
    const [policyData, setPolicyData] = useState([]);
    const [pageType, setPageType] = useState("add");
    const [subTabValue, setSubTabValue] = useState("userList");
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const [selectedPolicyId, setSelectedPolicyId] = useState(null);
    const [selectedPolicyTitle, setSelectedPolicyTitle] = useState(null);
    const [openAcknowledgementDialog, setOpenAcknowledgementDialog] = useState(false);
    const [openUserStatus, setOpenUserStatus] = useState(false);
    const [confirmationDialog, setConfirmationDialog] = useState({
      open: false,
      title: "",
      message: "",
      showCancel: true,
      showConfirm: true,
      customSection: null,
      onConfirm: () => {},
      onCancel: () => {},
    });    

    useEffect(() => {
        if(subTabValue === "userList"){
            //fetch user list policy function
           fetchUserListPolicy();

        }else if(subTabValue === "hrList"){
            //fetch hr list policy function
            fetchHrListPolicy();
        }else{
            return;
        }
    },[subTabValue]);

    const fetchUserListPolicy = async () => {
      try{
        setIsLoading(true);
        const response = await request(BASEURL, userPolicyList,{
          userId: userId
        });
        setPolicyData(response?.policyByUser || []);
        
      }catch(error){
        console.error("Error Fetching User Data:",error);
        setConfirmationDialog({
          open: true,
          title: "Error",
          message:
            "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }finally{
        setIsLoading(false);
      }
    }

    const fetchHrListPolicy = async () => {
      try{
        setIsLoading(true);
        const response = await request(BASEURL, allPolicyList);        
        setPolicyData(response?.allPolicies || []);
        
      }catch(error){
        console.error("Error Fetching HR Data:",error);
        setConfirmationDialog({
          open: true,
          title: "Error",
          message:
            "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }finally{
        setIsLoading(false);
      }
    }
    const policyListTablleData = {
        columns: [
            {
                field: "sno",
                headerName: "S.No.",
                flex: 0.4,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "title",
                headerName: "Policy Name",
                flex: 1,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "description",
                headerName: "Description",
                flex: 1.4,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "createdOn",
                headerName: "Created On",
                flex: 0.5,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            ...(subTabValue === "userList" ? [{
                field: "status",
                headerName: "Status",
                flex: 0.5,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            }] : []),
            {
                headerName: "Action",
                field: "action",
                name: "Action",
                flex: 0.5,
                disableColumnMenu: true,
                editable: false,
            },
        ],
        rows: (policyData || []).map((value, i) => ({
          id: value.id,
          sno: i + 1,
          policyId: subTabValue === "userList" ? value?.policy?.id : value.id,
          title: subTabValue === "userList" ? value?.policy?.title : value?.title,
          description: subTabValue === "userList" ? value?.policy?.description : value?.description,
          status: value?.status,
          createdOn: new Date(value?.createdAt).toLocaleDateString("en-CA"),
          action: (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.module === "PolicyManagement" && item.component === "ViewPolicy" && item.can_access
                ) && (
                  <Tooltip
                    title="View"
                    placement="top"
                    disableInteractive
                    onClick={() => handleReOpenPolicyDialog(subTabValue === "userList" ? value?.policy?.id : value.id, "view")}
                  >
                    <IconButton size="small">
                      <Visibility />
                    </IconButton>
                  </Tooltip>
              )}
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.module === "PolicyManagement" && item.component === "EditPolicy" && item.can_access
                ) && (
                  <Tooltip
                    title="Edit"
                    placement="top"
                    disableInteractive
                    onClick={() => handleReOpenPolicyDialog(subTabValue === "userList" ? value?.policy?.id : value.id, "edit")}
                  >
                    <IconButton size="small">
                      <Edit />
                    </IconButton>
                  </Tooltip>
              )}
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.module === "PolicyManagement" && item.component === "ViewUserStatus" && item.can_access
                ) && subTabValue === "hrList" && (
                  <Tooltip
                    onClick={() => handleUserStatusChangeDialog(value?.id, subTabValue === "userList" ? value?.policy?.title : value?.title)}
                    title="User Status"
                    placement="top"
                    disableInteractive
                  >
                    <IconButton size="small">
                      <PersonSearch />
                    </IconButton>
                  </Tooltip>
                )}
                {value?.status === "Pending" && subTabValue === "userList" &&(
                <Tooltip
                  onClick={() => handleAcknowledgeDialog(value?.id, subTabValue === "userList" ? value?.policy?.title : value?.title)}
                  title="Acknowledge / Ignore"
                  placement="top"
                  disableInteractive
                >
                  <IconButton size="small">
                    <Approval />
                  </IconButton>
                </Tooltip>
                )}
            </Box>
          ),
      })),
    };

    const handleUploadPolicy = () => {
        setPageType("add");
        setShowUploadDialog(true);
    }

    const handleSetSubTabValue = (_e, newValue) => {        
        setSubTabValue(newValue);
    };

    const handleReOpenPolicyDialog = (id, type) => {
      setSelectedPolicyId(id);
      setShowUploadDialog(true);
      setPageType(type);
    };

    const handleAcknowledgeDialog = (id, title) => {
      setOpenAcknowledgementDialog(true);
      setSelectedPolicyId(id);
      setSelectedPolicyTitle(title);
    };

    const handleUserStatusChangeDialog = (id, title) => {
      setOpenUserStatus(true);
      setSelectedPolicyId(id);
      setSelectedPolicyTitle(title);
    };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
        {showUploadDialog && (
            <PolicyFileUploadDialog
            open={showUploadDialog}
            setOpen={setShowUploadDialog}
            subTabValue={subTabValue}
            fetchUserListPolicy={fetchUserListPolicy}
            fetchHrListPolicy={fetchHrListPolicy}
            pageType={pageType}
            selectedPolicyId={selectedPolicyId}
            />
        )}
        {openAcknowledgementDialog && (
          <PolicyAcknowledgementDialog
            open={openAcknowledgementDialog}
            setOpen={setOpenAcknowledgementDialog}
            selectedPolicyId={selectedPolicyId}
            selectedPolicyTitle={selectedPolicyTitle}
            subTabValue={subTabValue}
            fetchUserListPolicy={fetchUserListPolicy}
            fetchHrListPolicy={fetchHrListPolicy}
          />
        )}
        {openUserStatus && (
          <PolicyUserStatus
          open={openUserStatus}
          setOpen={setOpenUserStatus}
          selectedPolicyId={selectedPolicyId}
          selectedPolicyTitle={selectedPolicyTitle}
          />
        )}
        <Card>
            <CardHeader
                title={
                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{
                        width: "100%",
                        position: "relative",
                    }}
                    >
                    <MaterialBox
                    sx={{
                        width: { xs: "auto", md: "100%" },
                        display: "flex",
                        justifyContent: { xs: "flex-start", md: "center" },
                    }}>
                        <MaterialBox width={{ xs: "100%", md: "30%" }}>
                            <AppBar position="static" >
                                <Tabs
                                orientation={"horizontal"}
                                value={subTabValue}
                                onChange={handleSetSubTabValue}
                                sx={{
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "12px",
                                    padding: "5px",
                                }}
                                >
                                    <Tab
                                    label="User List"
                                    value="userList"
                                    sx={{
                                    color: "#2c5da8",
                                    transition: "0.3s",
                                    "&:hover": {
                                        backgroundColor: "#e5e8ec",
                                        color: "#1348a5",
                                        borderRadius: "8px",
                                    },
                                    }}
                                    />
                                  {AccessData &&
                                  Array.isArray(AccessData) &&
                                  AccessData.some(
                                      (item) => item.module === "PolicyManagement" && item.component === "HrList" && item.can_access
                                  ) && (         
                                    <Tab
                                    label="HR List"
                                    value="hrList"
                                    sx={{
                                    color: "#2c5da8",
                                    transition: "0.3s",
                                    "&:hover": {
                                        backgroundColor: "#e5e8ec",
                                        color: "#1348a5",
                                        borderRadius: "8px",
                                    },
                                    }}
                                    />
                                  )}
                                </Tabs>
                            </AppBar>
                        </MaterialBox>
                    </MaterialBox>
                    {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                        (item) => item.module === "PolicyManagement" && item.component === "UploadPolicy" && item.can_access
                    ) && (
                    <MaterialBox sx={{
                        position: { xs: "static", md: "absolute" },
                        right: 0,
                        ml: "auto",
                    }}>
                        <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<FileUpload />}
                        onClick={handleUploadPolicy}
                        >
                        Policy
                        </MaterialButton>
                    </MaterialBox>
                    )}
                </Stack>
                
                }
                
            />
            <MaterialBox p={2}>
            <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                    Policy Management List
                </MaterialTypography>
                <MaterialTypography variant="caption" fontWeight="medium">
                    List of Policies Uploaded by the company
                </MaterialTypography>
            </Stack>
            </MaterialBox>
            <MaterialDataGrid
                rows={policyListTablleData.rows}
                columns={policyListTablleData.columns}
                loading={isLoading}
                noSearch={false}
                localeText={{
                noRowsLabel: (
                    <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    >
                    <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                    >
                        {"No Policies Uploaded yet"}
                    </MaterialTypography>
                    </Stack>
                ),
                }}
            />
        </Card>
    </DashboardLayout>
  )
}

export default PolicyManagementList